import {UserCatchReport} from "../dtos/UserCatchReport";
import {Table} from "react-bootstrap";
import TimestampFormat from "../utils/TimestampFormat";
import React from "react";

export default function CatchesTable({
    catches,
    showTitle = true
}: {
    catches: UserCatchReport[];
    showTitle?: boolean;
}) {

    if (catches.length === 0) {
        return <h3>Bisher wurden keine Fänge eingetragen</h3>
    }

    return <>
        {showTitle ? <h2>Eingetragene Fänge</h2> : null}
        <div className="table-responsive">
        <Table hover>
            <thead>
            <tr>
                <th>Fisch</th>
                <th>Gewässer</th>
                <th>Länge (cm)</th>
                <th>Entnommen</th>
                <th>Fangzeitpunkt</th>
            </tr>
            </thead>
            <tbody>
            {catches.map((c) => (
                <tr key={c.id}>
                    <td>{c.fishName}</td>
                    <td>{c.waterName}</td>
                    <td>{c.fishLength}</td>
                    <td>{getWasTakenLabel(c.wasTaken)}</td>
                    <td>{TimestampFormat.toDateOnlyReadableFormat(c.catchTime)}</td>
                </tr>
            ))}
            </tbody>
        </Table>
        </div>
    </>
}

function getWasTakenLabel(value: Boolean | undefined | null): string {
    if (value === true) return "Ja";
    if (value === false) return "Nein";
    return "Unbekannt";
}
